// import $ from 'jquery';
// import { CLASSES } from '@/scripts/helpers/constants/classes';
// import { BREAKPOINTS } from '@/scripts/helpers/constants/breakPoints';

// const { TABLET_LG } = BREAKPOINTS;
// const { IS_OPEN } = CLASSES;



export const categoriesMenu = (selector = '.js-categories-menu') => {
  const menu = document.querySelector(selector);
  


  // const mediaQuery = window.matchMedia(breakpoint);

  

  // if (mediaQuery.matches && menu.length) {
  //   menu.classList.add('categories-menu--desktop-lg');
  // }
  if (menu) {
    const links = menu.querySelectorAll('.categories-menu__link');
    
    menu.addEventListener('click', (e) => {
      if (window.innerWidth < 1000) {
        menu.classList.toggle("is-open");
      }
    });
    document.addEventListener('click', (e) => {
      if (window.innerWidth < 1000) {
        // if (e.target.closest('.js-categories-menu').length === 0 && menu.length) {
        //   menu.classList.remove("is-open");
        // }
        if (!e.target.matches(selector) && menu.classList.contains("is-open")) {
          menu.classList.remove("is-open");
        }
      }
    });
  
    links.forEach(link => {
      link.addEventListener('click', event => {
        links.forEach(menuItem => menuItem.classList.remove("is-active"));
        link.classList.add("is-active");
        const text = event.target.textContent;
        const toUpdateText = document.querySelector('.categories-menu__label');
  
        toUpdateText.textContent = text;
      });
    });
  }

  
};
